/* Get header and footer heights */
document.addEventListener('DOMContentLoaded', function () {
  var header = document.querySelector('.section-header');
  var footer = document.querySelector('.section-footer');

  var headerHeight = header.offsetHeight;
  var footerHeight = footer.offsetHeight;

  document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
  document.documentElement.style.setProperty('--footer-height', footerHeight + 'px');
});

/* Format titles */
// const headings = document.querySelectorAll('.card__heading, .product__title h1, .featured-product .product__title, .cart-item__name, .page-title, .related-products .card__heading.h5, .card__heading.h5');

// headings.forEach(heading => {
//   heading.innerHTML = heading.innerHTML.replace(/\|/g, '<br><small />');
// });


/* Get Browser */
document.addEventListener("DOMContentLoaded", function () {
  let browser = "unknown";

  if (navigator.userAgent.indexOf("Chrome") !== -1 && navigator.userAgent.indexOf("Edg") === -1) {
    browser = "browser--chrome";
  } else if (navigator.userAgent.indexOf("Firefox") !== -1) {
    browser = "browser--firefox";
  } else if (navigator.userAgent.indexOf("Safari") !== -1 && navigator.userAgent.indexOf("Chrome") === -1) {
    browser = "browser--safari";
  } else if (navigator.userAgent.indexOf("Edg") !== -1) {
    browser = "browser--edge";
  } else if (navigator.userAgent.indexOf("Opera") !== -1 || navigator.userAgent.indexOf("OPR") !== -1) {
    browser = "browser--opera";
  } else if (navigator.userAgent.indexOf("MSIE") !== -1 || navigator.userAgent.indexOf("Trident") !== -1) {
    browser = "browser--ie";
  }

  document.body.classList.add(browser);
});
